export const CatalogUpload = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.33333 3.33333C5.1242 3.33333 3.33333 5.1242 3.33333 7.33333V16.6667C3.33333 16.7949 3.33937 16.9218 3.35117 17.0469L4.86297 14.628C6.5389 11.9466 10.3402 11.673 12.3828 14.087L14.1056 16.123C15.6293 13.8215 19.1389 13.7917 20.6667 16.1805V12C20.6667 11.6318 20.9651 11.3333 21.3333 11.3333C21.7015 11.3333 22 11.6318 22 12V16.6667C22 19.6122 19.6122 22 16.6667 22H7.33333C4.38781 22 2 19.6122 2 16.6667V7.33333C2 4.38781 4.38781 2 7.33333 2H12C12.3682 2 12.6667 2.29848 12.6667 2.66667C12.6667 3.03486 12.3682 3.33333 12 3.33333H7.33333ZM20.2821 18.3802L19.7072 17.1924C18.7476 15.2096 15.938 15.2607 15.0229 17.2071L17.81 20.5009C18.9029 20.1755 19.8 19.3955 20.2821 18.3802ZM7.33333 20.6667C5.8673 20.6667 4.58544 19.878 3.88898 18.7017C3.89226 18.6968 3.89549 18.6917 3.89866 18.6867L5.99363 15.3347C7.19073 13.4194 9.90597 13.224 11.3649 14.9482L16.2036 20.6667H7.33333Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.1126 6.4959C20.839 6.7422 20.4174 6.72 20.1711 6.44633L18.3333 4.40434V10.0004C18.3333 10.3686 18.0349 10.667 17.6667 10.667C17.2985 10.667 17 10.3686 17 10.0004V4.40433L15.1622 6.44633C14.9159 6.72 14.4944 6.7422 14.2207 6.4959C13.947 6.2496 13.9248 5.82807 14.1711 5.5544L16.1801 3.32223C16.9746 2.43947 18.3588 2.43947 19.1533 3.32223L21.1622 5.5544C21.4085 5.82807 21.3863 6.2496 21.1126 6.4959Z"
      />
    </svg>
  );
};
